import createImageUrlBuilder from '@sanity/image-url'
import type { ImageUrlBuilder } from 'sanity'

import type { ImageBuilderProps, SanityImage } from '@/constant/types'
import { dataset, projectId } from '@/sanity/lib/env'

const imageBuilder = createImageUrlBuilder({
  projectId: projectId || '',
  dataset: dataset || '',
})

export const urlForImage = (
  source: SanityImage,
  props: ImageBuilderProps = {},
): ImageUrlBuilder => {
  const { width, height } = props
  if (width && height) {
    return imageBuilder
      .image(source)
      .auto('format')
      .width(width)
      .height(height)
      .fit('crop')
  }
  return imageBuilder.image(source).auto('format').fit('max')
}

export function urlForOpenGraphImage(image: SanityImage) {
  return urlForImage(image)?.width(1200).height(630).fit('crop').url()
}
